import type { MouseEventHandler } from "react";
import { MoreHorizontalIcon } from "lucide-react";

import { COARSE_POINTER_HIT_AREA_CLASS } from "~/lib/touchTarget";
import { Tooltip, TooltipPopup, TooltipTrigger } from "../ui/tooltip";

interface SidebarProjectActionsButtonProps {
  readonly onClick: MouseEventHandler<HTMLButtonElement>;
}

export function SidebarProjectActionsButton({ onClick }: SidebarProjectActionsButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <button
            type="button"
            aria-label="Project actions"
            data-testid="project-actions-button"
            className={`${COARSE_POINTER_HIT_AREA_CLASS} inline-flex size-5 items-center justify-center rounded-md text-muted-foreground/65 opacity-0 transition-[color,background-color,opacity] hover:bg-secondary hover:text-foreground focus-visible:opacity-100 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring group-hover/project-header:opacity-100 group-focus-within/project-header:opacity-100`}
            onClick={onClick}
          />
        }
      >
        <MoreHorizontalIcon className="size-3.5" />
      </TooltipTrigger>
      <TooltipPopup side="top">Project actions</TooltipPopup>
    </Tooltip>
  );
}
